import React, { useCallback, useContext } from "react";
import { useParams } from "react-router-dom";

import ModalForm from "@/elements/ModalForm";
import TusHooks from "@/hooks/UseTusHooks/TusHooks.tsx";
import { publishToWorkspaceFeed } from "@/models/actions/clientActions.ts";
import { FeedContext } from "@/models/FeedContextProvider";

export default function FileUploadModal() {
  const { fileUploadModal, setFileUploadModal } = useContext(FeedContext);
  const { workspaceId, feedId } = useParams();

  const publishAfterUpload = useCallback(
    async ({ contentId, itemId }: { contentId: string; itemId: string }) => {
      await publishToWorkspaceFeed({
        workspaceId,
        feedId,
        contentId,
        itemId,
        isSilent: true,
      });
      setFileUploadModal(false);
    },
    [workspaceId, feedId, setFileUploadModal],
  );

  return (
    <ModalForm
      id="file-upload"
      open={fileUploadModal}
      onClose={() => setFileUploadModal(false)}
      sx={{
        justifyContent: "center",
        flexGrow: 1,
        overflow: "hidden",
      }}
    >
      <TusHooks setUploadContent={publishAfterUpload} feedId={feedId} />
    </ModalForm>
  );
}
